import { render, staticRenderFns } from "./SponsoredRecommendationImageSearch.vue?vue&type=template&id=09bae6f0&scoped=true"
import script from "./SponsoredRecommendationImageSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationImageSearch.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationImageSearch.vue?vue&type=style&index=0&id=09bae6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bae6f0",
  null
  
)

export default component.exports